import * as React from 'react';
import { useContext } from 'react';
import { DisplayConfigType } from '../lib/config';
import { StoreContext } from '../lib/store';
import { ComponentsBuilder } from './component-builder';
import style from './styles.scss';

export function Display({}: Partial<DisplayConfigType>) {
  const store = useContext(StoreContext);

  const components = ComponentsBuilder.build(
    store.adContext,
    store.formatConfig as DisplayConfigType
  ).map(c => {
    const C = c.component;
    return <C key={c.key}></C>;
  });

  const onTouchMove = store.userDragHandler
    ? () => store.userDragHandler.handle()
    : undefined;

  return (
    <div id="format" className={style.format} onTouchMove={onTouchMove}>
      {components}
    </div>
  );
}
